import React, { useContext, useEffect, useMemo } from "react";
import { useI18n } from "../../hooks/i18n-hooks";
import { GET_ALL_TIMESHEETS } from "../../graphql/timesheet";
import { useQuery } from "@apollo/client";
import Loading from "../../components/Loading";
import TimesheetList from "../../components/TimeSheetList";
import EmptyScreen from "../../components/EmptyScreen";
import { useMissionsTimesheetNotification } from "../../hooks/push-notification";
import { TimeSheetState } from "../../__generated__/graphql";
import NoTimesheetImage from "../../assets/images/no-timesheet-image.svg";
import ScreenCard from "../ScreenCard";
import { ProfileSwitcherManagerContext } from "../../contexts/ProfileSwitcherManager";
import { buildErrorHeadband } from "../ScreenCardHeadband";

const TimeSheetListScreen = () => {
    const i18n = useI18n();
    const { profileType } = useContext(ProfileSwitcherManagerContext);
    const [hasPendingTimeSheet, setHasPendingTimeSheet] = React.useState<boolean>();
    const { data, refetch, loading, error } = useQuery(GET_ALL_TIMESHEETS, {
        variables: {},
        fetchPolicy: "cache-and-network",
    });
    const allTimeSheets = useMemo(
        () => data?.getAllTimeSheets.elements || [],
        [data?.getAllTimeSheets.elements],
    );
    const count = useMemo(() => data?.getAllTimeSheets.count || 0, [data?.getAllTimeSheets.count]);

    useEffect(() => {
        if (allTimeSheets) {
            setHasPendingTimeSheet(allTimeSheets.some((ts) => ts.status === TimeSheetState.Open));
        }
    }, [allTimeSheets]);

    useMissionsTimesheetNotification(hasPendingTimeSheet);

    const isInitialLoading = loading && !data;

    return (
        <ScreenCard
            refresh={refetch}
            isContentContainerFlex={count === 0 || isInitialLoading}
            headband={
                error
                    ? buildErrorHeadband(i18n.t("screens.user.timesheets.cannot_load_timesheets"))
                    : undefined
            }
        >
            {isInitialLoading ? (
                <Loading />
            ) : count > 0 && profileType ? (
                <TimesheetList profileType={profileType} timeSheets={allTimeSheets} />
            ) : (
                <EmptyScreen image={NoTimesheetImage} text={i18n.t("time_sheet.empty")} />
            )}
        </ScreenCard>
    );
};

export default TimeSheetListScreen;
